// import React from 'react';
// import styles from './styles.module.css';
// import { setState, toc } from '@/commonTypes';

// export default function BlogMenu({ tocData, activeId }: { tocData?: toc[]; activeId?: string }) {
//   return (
//     <aside className={`${styles.toc}`} id="toc">
//       <div className={`${styles.toc_label}`} data-en="ON THIS PAGE" data-fa-html="در این مقاله">
//         در این مقاله
//       </div>
//       <ul className="toc-list">
//         {tocData?.map((item) => (
//           <li
//             key={item.id}
//             className={`toc-item level-${item.level} ${activeId === item.id ? styles.active : ''}`}
//             onClick={() => {
//               // setActiveId(item?.id);
//             }}
//           >
//             <a href={`#${item.id}`}>{item.title}</a>
//           </li>
//         ))}
//       </ul>
//     </aside>
//   );
// }

import React from 'react';
import styles from './styles.module.css';
import { setState, toc } from '@/commonTypes';
import MenuTemplate from '@/components/structure/MenuTemplate';
import MainIcons from '@/icons/main';
import useWindowDimensions from '@/functions/useWindowDimensions';
import { useTranslations } from 'next-intl';

export default function BlogMenu({
  tocData,
  activeId,
  setActiveId,
}: {
  tocData?: toc[];
  activeId?: string;
  setActiveId?: setState<string | undefined>;
}) {
  // const { width } = useWindowDimensions();
  const { width } = useWindowDimensions();
  const tCommon = useTranslations('common');
  const renderItem = () => (
    <aside className={`${styles.toc}`} id="toc">
      <div className={`${styles.toc_label}`}>{tCommon('inthisarticle')}</div>
      <ul className={`${styles.toc_list}`}>
        {tocData?.map((item) => (
          <li
            key={item.id}
            className={`toc-item level-${item.level} ${activeId === item.id ? styles.active : ''}`}
            onClick={(e) => {
              // setActiveId && setActiveId(item?.id);
              // document.getElementById(item?.id)?.scrollIntoView({
              //   behavior: 'smooth',
              // });
              e.preventDefault();
              // setTimeout(() => {
              //   setActiveId?.(item.id);
              // }, 500);

              item.id &&
                document.getElementById(item.id)?.scrollIntoView({
                  behavior: 'smooth',
                  block: 'start',
                });
            }}
          >
            <a href={`#${item.id}`}>{item.title}</a>
          </li>
        ))}
      </ul>
    </aside>
  );
  console.log('width==', width);
  return (
    <>
      {typeof window !== 'undefined' && typeof document !== 'undefined' && (
        <>
          {width && width > 1001 ? (
            <>{renderItem()}</>
          ) : (
            <MenuTemplate
              // className={`${styles.menuClassName}`}
              headClassName={`${styles.moreIcon}`}
              headChild={
                <div className={`${styles.menuIconContainer}`}>
                  <MainIcons.MenuIcon fill="var(--text-dark)" />
                </div>
              }
              listClassName={`${styles.listContainer}`}
              className={`${styles.toc}`}
            >
              {renderItem()}
            </MenuTemplate>
          )}
        </>
      )}
    </>
  );
}
